import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'lib-form-toggle',
  templateUrl: './form-toggle.component.html',
  styleUrls: ['./form-toggle.component.scss', '../form.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatSlideToggleModule],
})
export class FormToggleComponent {
  label = input<string>();
  value = input.required<any>();
  isChecked = input<boolean>(false);
  disabled = input<boolean>(false);
  checked = output<{ checked: boolean; value: any }>();

  updateValue(event: MatSlideToggleChange) {
    this.checked.emit({ value: this.value(), checked: event.checked });
  }
}
